import React from 'react';
import { ButtonStandard, Text } from '@stashinvest/react-components';
import { ChatAnalytics, TrackFunction } from './types';
import {
	v1_AiChatSuggestedTopic_Clicked,
	v1_AiChat_Submitted,
} from '@stashinvest/product-events-javascript/lib/v1/event_static_methods';
import { v1_AiChat_SubmittedProperties } from '@stashinvest/product-events-javascript/lib/v1/properties';

type ChatTopicsProps = {
	topics: string[];
	loading: boolean;
	onSubmit: (topic: string) => void;
	analytics: ChatAnalytics;
	track: TrackFunction;
};

export const ChatTopics = ({
	topics,
	loading,
	onSubmit,
	analytics,
	track,
}: ChatTopicsProps) => {
	const handleSubmit = (topic: string) => {
		track(v1_AiChatSuggestedTopic_Clicked({ ...analytics, topic }));
		track(
			v1_AiChat_Submitted({
				...analytics,
				is_topic: v1_AiChat_SubmittedProperties.IsTopic.yes,
			})
		);
		onSubmit(topic);
	};
	return (
		<>
			{topics.map((topic) => (
				<div key={topic} className="pl-[1px] my-content2XS">
					<ButtonStandard
						key={topic}
						style={{ width: '100%' }}
						className="w-full max-w-[300px]"
						size="small"
						variant="outline"
						disabled={loading}
						onClick={() => handleSubmit(topic)}
					>
						<Text textStyle="bodySmallStandard">{topic}</Text>
					</ButtonStandard>
				</div>
			))}
		</>
	);
};
